import logo from './logo.svg';
import './App.css';
import './index.css';
import Appstart from './components/Appstart';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
  return (
        <Provider store={store}>
                <Appstart/>
        </Provider>

  );
}

export default App;
